import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
	// 登录
	{
		name: 'login',
		path: '/login',
		component: () => import('@/views/login'),
		meta: {}
	},
	// 首页
	{
		path: '/',
		component: Layout,
		redirect: '/home',
		name: 'home',
		meta: {},
		children: [
			// 首页
			{
				path: 'home',
				component: () => import('@/views/home/index.vue'),
				name: 'home',
				meta: {
					perm: 'm_index',
					title: '首页'
				}
			},
		]
	},
	// 业务数据查询
	{
		path: '/businessData',
		component: Layout,
		name: 'businessData',
		meta: {
			perm: 'm_business_data',
			title: '首业务数据查询页'
		},
		children: [
			// 客商订单
			{
				path: 'merchantOrder',
				component: () => import('@/views/businessData/merchantOrder'),
				name: 'merchantOrder',
				meta: {
					perm: 'm_order',
					title: '客商订单'
				}
			},
			// 收款单
			{
				path: 'collectionOrder',
				component: () => import('@/views/businessData/collectionOrder'),
				name: 'collectionOrder',
				meta: {
					perm: 'm_receipt',
					title: '收款单'
				}
			},
			// 装车单
			{
				path: 'shipOrder',
				component: () => import('@/views/businessData/shipOrder'),
				name: 'shipOrder',
				meta: {
					perm: 'm_load_vehicle',
					title: '装车单'
				}
			},
			// 生动化检查
			{
				path: 'vividCheck',
				component: () => import('@/views/businessData/vividCheck'),
				name: 'vividCheck',
				meta: {
					perm: 'm_store_check',
					title: '生动化检查'
				}
			},
			// 客商库存
			{
				path: 'agentStock',
				component: () => import('@/views/businessData/agentStock'),
				name: 'agentStock',
				meta: {
					perm: 'm_agent_stock',
					title: '客商库存'
				}
			},
			// 其它出库单
			{
				path: 'otherOrder',
				component: () => import('@/views/businessData/otherOrder'),
				name: 'otherOrder',
				meta: {
					perm: 'm_other_out',
					title: '其它出库单'
				}
			},

			// 签到拜访表
			{
				path: 'signForm',
				component: () => import('@/views/businessData/signForm'),
				name: 'signForm',
				meta: {
					perm: 'm_signin',
					title: '签到拜访表'
				}
			}
		]
	},
	// 业务报表
	{
		path: '/businessTable',
		component: Layout,
		name: 'businessTable',
		meta: {
			perm: 'm_report',
			title: '业务报表'
		},
		children: [
			// 巡回日报
			{
				path: 'tourDaily',
				component: () => import('@/views/businessTable/tourDaily'),
				name: 'tourDaily',
				meta: {
					perm: 'm_round_report',
					title: '巡回日报'
				}
			},
			// 客商台账
			{
				path: 'merchantAccount',
				component: () => import('@/views/businessTable/merchantAccount'),
				name: 'merchantAccount',
				meta: {
					perm: 'm_agent_book',
					title: '客商台账'
				}
			},
			// 销售台账
			{
				path: 'saleAccount',
				component: () => import('@/views/businessTable/saleAccount'),
				name: 'saleAccount',
				meta: {
					perm: 'm_agent_sale_book',
					title: '销售台账'
				}
			},
		]
	},
	// 路线管理
	{
		path: '/routeManagement',
		component: Layout,
		name: 'routeManagement',
		meta: {
			perm: 'm_route',
			title: '路线管理'
		},
		children: [
			// 路线
			{
				path: 'route',
				component: () => import('@/views/routeManagement/route'),
				name: 'route',
				meta: {
					perm: 'm_route_set',
					title: '路线'
				}
			},
			// 路线地图
			{
				path: 'map',
				component: () => import('@/views/routeManagement/map'),
				name: 'map',
				meta: {
					perm: 'm_route_map',
					title: '路线地图'
				}
			},
			// 巡回计划
			{
				path: 'tour',
				component: () => import('@/views/routeManagement/tour'),
				name: 'tour',
				meta: {
					perm: 'm_round_set',
					title: '巡回计划'
				}
			},
			// 路线目标管理
			{
				path: 'goal',
				component: () => import('@/views/routeManagement/goal'),
				name: 'goal',
				meta: {
					perm: 'm_route_goal',
					title: '路线目标管理'
				}
			}
		]
	},
	// 客商管理
	{
		path: '/merchantManagement',
		component: Layout,
		name: 'merchantManagement',
		meta: {
			perm: 'm_agent_mgr',
			title: '客商管理'
		},
		children: [
			// 客商信息
			{
				path: 'info',
				component: () => import('@/views/merchantManagement/info'),
				name: 'info',
				meta: {
					perm: 'm_agern_info',
					title: '客商信息'
				}
			},
			// 预付款额度
			{
				path: 'subsist',
				component: () => import('@/views/merchantManagement/subsist'),
				name: 'subsist',
				meta: {
					perm: 'm_agent_limit',
					title: '预付款额度'
				}
			},
			// 出货仓设置
			{
				path: 'warehouse',
				component: () => import('@/views/merchantManagement/warehouse'),
				name: 'warehouse',
				meta: {
					perm: 'm_warehouse_set',
					title: '出货仓设置'
				}
			}
		]
	},
	// 基础数据管理
	{
		path: '/baseDataManagement',
		component: Layout,
		name: 'baseDataManagement',
		meta: {
			perm: 'm_bdata',
			title: '基础数据管理'
		},
		children: [
			// sku管理
			{
				path: 'skuManage',
				component: () => import('@/views/baseDataManagement/skuManage'),
				name: 'skuManage',
				meta: {
					perm: 'm_sku_set',
					title: 'sku管理'
				}
			},
			// 数据字典
			{
				path: 'dataDictionary',
				component: () => import('@/views/baseDataManagement/dataDictionary'),
				name: 'dataDictionary',
				meta: {
					perm: 'm_code_set',
					title: '数据字典'
				}
			},
			// 价格管理
			{
				path: 'priceManage',
				component: () => import('@/views/baseDataManagement/priceManage'),
				name: 'priceManage',
				meta: {
					perm: 'm_price_set',
					title: '价格管理'
				}
			},
			// 自动贩卖机
			{
				path: 'automaticPrice',
				component: () => import('@/views/baseDataManagement/automaticPrice'),
				name: 'automaticPrice',
				meta: {
					perm: 'm_auto_sale_price_set',
					title: '自贩价格管理'
				}
			},
		]
	},
	// 车辆管理
	{
		path: '/vehicleManagement',
		component: Layout,
		name: 'vehicleManagement',
		meta: {
			perm: 'm_vehicle',
			title: '车辆管理'
		},
		children: [
			// 车辆信息
			{
				path: 'vehicleInfo',
				component: () => import('@/views/vehicleManagement/info'),
				name: 'vehicleInfo',
				meta: {
					perm: 'm_vehicle_info',
					title: '车辆信息'
				}
			},
			// 车辆加油
			{
				path: 'refuel',
				component: () => import('@/views/vehicleManagement/refuel'),
				name: 'refuel',
				meta: {
					perm: 'm_vehicle_refuel',
					title: '车辆加油'
				}
			},
			// 车辆里程
			{
				path: 'mileage',
				component: () => import('@/views/vehicleManagement/mileage'),
				name: 'mileage',
				meta: {
					perm: 'm_vehicle_mileage',
					title: '车辆里程'
				}
			},
		]
	},
	// 系统管理
	{
		path: '/systemManagement',
		component: Layout,
		name: 'systemManagement',
		meta: {
			perm: 'm_sys_set',
			title: '系统管理'
		},
		children: [
			// 用户管理
			{
				path: 'userManagement',
				component: () => import('@/views/systemManagement/userManagement'),
				name: 'userManagement',
				meta: {
					perm: 'm_sys_user',
					title: '用户管理'
				}
			},
			// 角色管理
			{
				path: 'roleManagement',
				component: () => import('@/views/systemManagement/roleManagement'),
				name: 'roleManagement',
				meta: {
					perm: 'm_sys_role',
					title: '角色管理'
				}
			},
			// 组织设定
			{
				path: 'groupSet',
				component: () => import('@/views/systemManagement/groupSet'),
				name: 'groupSet',
				meta: {
					perm: 'm_sys_group',
					title: '组织设定'
				}
			},
		]
	}

]

const router = new VueRouter({
	routes
})

export default router

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach((to, from, next) => {
	// 权限
	if (window.sessionStorage.getItem('perms')) {
		let perms = JSON.parse(window.sessionStorage.getItem('perms'));
		if (!perms.includes(to.meta.perm)) {
			if (to.name == 'login') {
				window.sessionStorage.clear();
				next();
			}
			return
		} else {
			// token
			if (to.name == 'login') {
				window.sessionStorage.clear();
				next();
			} else if (window.sessionStorage.getItem('token')) {
				// 禁止浏览器前进后退
				if(store.state.app.forbid_back) {
					// 释放
					store.commit('app/SET_FORBID_BACK',false);
					next(false);
				}else {
					next();
				}
			} else {
				window.sessionStorage.clear();
				next({
					path: '/login'
				});
			}
		}
	}
	// 无权限
	else {
		// token
		if (to.name == 'login') {
			window.sessionStorage.clear();
			next();
		} else if (window.sessionStorage.getItem('token')) {
			next();
		} else {
			window.sessionStorage.clear();
			next({
				path: '/login'
			});
		}
	}
})


